import Service from './Service.js';

const resource = 'validaciontelematica';

export default {

    get(codigo) {
        return Service.get(resource, {
            params: {
                codigo
            }
        });
    }

}
